import axios from "axios";
import {
    urlReplacementLists,
    urlReplacementDetail,
    urlReplacementJobProposal,
    urlReplacementResign,
    urlReplacementName,
    urlReplacementReject,
    jobOffer
} from "./services.config";
import { Replacement } from "../../domain/entities/replacement/Replacement";
import ReplacementJobReject from "../../domain/entities/replacement/ReplacementJobReject";

export const getReplacementLists = function(){
    return new Promise( (resolve, reject) => {
        resolve(axios.get(urlReplacementLists()));
    })
}

export const getReplacementDetail = function (id: string) : Promise<{data: Replacement}> {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlReplacementDetail(id)));
    })
}

export const getReplacementJobProposal = function (id: string) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlReplacementJobProposal(id)));
    })
}

export const resignReplacement = function (token: string) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlReplacementResign(token)));
    })
}

export const rejectReplacement = function (command: ReplacementJobReject) {
    return new Promise((resolve, reject) => {
        resolve(axios.post(urlReplacementReject(), command.toServer()));
    })
}

export const getReplacementName = function (id: string) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlReplacementName(id)));
    })
}

export const getJobOfferResponse = async (token: string): Promise<string> => {
    try {
        const response = await axios.get(jobOffer(token));
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
